import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "list",
  ref: "listAuto",
  id: "list-autocomplete"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "md:text-sm lg:text-sm hover-primary" }
const _hoisted_4 = {
  key: 1,
  class: "py-4"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "text-center color-blue-grey font-medium text-sm" }, "Pencarian tidak ditemukan", -1)
const _hoisted_6 = {
  ref: "placeMap",
  id: "placeMap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      id: "overlay_panel",
      breakpoints: {'960px': '75vw', '640px': '100vw'},
      style: _ctx.stylesOverlay
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          (_ctx.data.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "mx-4 py-2 cursor-pointer",
                    style: {"border-bottom":".5px solid rgba(0,0,0,.3)"},
                    onClick: ($event: any) => (_ctx.clickPlace(item.place_id)),
                    key: 'go'+index
                  }, [
                    _createVNode("p", _hoisted_3, _toDisplayString(item.description), 1)
                  ], 8, ["onClick"]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_4, [
                _hoisted_5
              ]))
        ], 512)
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode("div", _hoisted_6, null, 512)
  ]))
}